<template>
    <div class="addons" v-if="selection">

        <article class="wrap--product">

            <header class="addons__header border-b padding-b-25 margin-b-50">

                <h1>{{selection.title}}</h1>
                <h2 :class="selectionClass"> Vælg: {{currentSelectionQuantity}}/{{quantity}} stk. <transition name="fade"> <i class="fas fa-check" v-if="currentSelectionQuantity === quantity"></i></transition></h2>

            </header>

            <main class="addons__items">

                <option-item v-for="option in selection.options" :option="option" :selection="selection" :key="option.id" @input="updateSelectionQuantity" :start-quantity="getOptionStartQuantity(option)"></option-item>

            </main>

        </article>

    </div>
</template>

<script>
    import Option from './option.vue';
    import PlusMinusNumberInput from './../partials/PlusMinusNumberInput.vue';
    import {mapGetters} from 'vuex';
    export default {
        name: "selection-item",
        data(){
            return {
                currentSelectionQuantity:0,
            }
        },
        components:{
            'incrementer':PlusMinusNumberInput,
            'option-item':Option,
        },
        props:{
            selection:{
                type: Object,
                required: true,
            }
        },
        computed: {
            ...mapGetters({
                product: 'product',
                order: 'order',
            }),
            quantity: {
                get() {
                    return this.order.details.quantity;
                },
            },
            selectionClass(){
                return this.currentSelectionQuantity === this.quantity ? 'success':'error';
            }
        },
        methods:{
            selectionQuantities(){
                const selection = this.order.details.selections.find(selection => {
                    return selection.selection_id === this.selection.id;
                });

                if(selection && selection.options && selection.options.length > 0){
                    return selection.options.map(option => option.quantity).reduce((acc, cur) => acc + cur);
                }

                return 0;
            },
            updateSelectionQuantity(){
                this.currentSelectionQuantity = this.selectionQuantities();
            },
            getOptionStartQuantity(option){
                const selection = this.order.details.selections.find(selection => {
                    return selection.selection_id === this.selection.id;
                });

                let optionData = null

                if(selection && selection.options){
                    optionData = selection.options.find(item => item.id === option.id);
                }

                if(!optionData){
                    return 0;
                }

                return optionData.quantity;
            }
        },
        created() {
            this.updateSelectionQuantity();
        }

    }
</script>

<style scoped>

</style>
